
export default [ 
    {
      "question": "What types of bags does Bella Vega offer?",
      'answer': "We offer a curated collection of tote bags, sling bags, shoulder bags, party bags, and everyday essentials designed for modern women."
    },
    {
      "question": "Are Bella Vega bags suitable for daily use?",
      'answer': "Yes. Our bags are designed for both daily use and special occasions, combining durability with elegant style."
    },
    {
      "question": "What materials are used in Bella Vega bags?",
      'answer': "We use premium PU leather, vegan leather, fabric blends, and high-quality metal fittings for long-lasting performance."
    },
    {
      question: "Are the bags waterproof?",
      answer: "Our bags are water-resistant but not fully waterproof. We recommend avoiding heavy rain exposure."
    }, 
    {
      "question": "What type of zippers are used?",
      'answer': "We use YKK zippers or equivalent premium-quality zippers for smooth and durable performance."
    },
  {
    "question": "Do you deliver across India?",
    'answer': "Yes, we deliver to most locations across India. "
  },
  {
    "question": "How long does delivery take?",
    'answer': "Orders are usually delivered within 3–7 business days, depending on your location."
  },
  {
    "question": "What is your return policy?",
    'answer': "We offer an easy 7-day return policy for unused products in original condition with tags intact."
  }
  ]